import Vue from 'vue';
import VScrollThreshold from 'v-scroll-threshold';
 
Vue.use(VScrollThreshold);